export default function ReturnPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Embedded Termly Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <iframe
            src="https://app.termly.io/policy-viewer/policy.html?policyUUID=3d9e91d8-79fd-4fa2-a472-d9a427994f76"
            className="w-full border-0"
            style={{ minHeight: '100vh' }}
            title="Return Policy"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        </div>
      </div>
    </div>
  )
}
